module.exports = __webpack_public_path__ + "static/mask_lo_012-6ae91b8e568b5b6555bea3d65706134e.jpg";